import { preloadPostOfficeConfluenceSideNav } from '@confluence/experiment-post-office-side-nav/entry-points/preloadConfluenceSideNav';
import { fg } from '@confluence/feature-gating';
import {
	getPreloaderFnContext,
	query,
	waitForAllReturnWhenError,
} from '@confluence/query-preloader-tools';
import { preloadUseExtensionList } from '@confluence/forge-ui/entry-points/preloadUseExtensionList';
import { FORGE_MODULE_SPACE_PAGE } from '@confluence/forge-ui/entry-points/ForgeModuleType';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation';
import { getIsNav4Enabled } from '@confluence/nav4-enabled/entry-points/getIsNav4Enabled';
import { expVal } from '@confluence/feature-experiments';
import { preloadPersistentInviteButtonEligible } from '@confluence/persistent-invite-button/entry-points/preloadPersistentInviteEligible';

import { SpaceNavigationQuery } from './SpaceNavigation/SpaceNavigationQuery.graphql';
import { preloadGlobalAppShortcutsLicensedProducts } from './GlobalNavigation/GlobalAppShortcuts/preloadGlobalAppShortcutsLicensedProducts';

export async function preloadSideNavigationNeedsContentId(spaceKey: string, contentId: string) {
	if (expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		return Promise.resolve();
	}

	return preloadUseExtensionList({
		contentId,
		spaceKey,
		moduleType: FORGE_MODULE_SPACE_PAGE,
	});
}

export async function preloadSideNavigation(spaceKey: string) {
	const preloadedSessionContext = getPreloaderFnContext();
	const isNav4Enabled = getIsNav4Enabled();

	const tasks: Array<Promise<any>> = [];

	if (!expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		tasks.push(
			query({
				query: SpaceNavigationQuery,
				variables: {
					spaceKey,
					isLicensed: preloadedSessionContext.isLicensed,
				},
			}),
		);
	}

	tasks.push(
		preloadPersistentInviteButtonEligible(
			{ spaceKey },
			expVal('confluence_unified_space_preloader', 'isEnabled', false),
		),
	);

	if (isNav4Enabled) {
		tasks.push(
			preloadWebItemLocation({
				location: 'system.header/left',
			}),
		);
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		if (fg('nav4_confluence_global_links') && fg('confluence_preload_tenant_license_gas')) {
			tasks.push(preloadGlobalAppShortcutsLicensedProducts());
		}
	}

	if (fg('po-connie-side-nav-ssr-shadow')) {
		tasks.push(preloadPostOfficeConfluenceSideNav(preloadedSessionContext));
	}

	return waitForAllReturnWhenError(tasks);
}
